import { decode } from 'jsonwebtoken';
function tokenIsExpired(token) {
    var decoded = token && decode(token);
    return !(decoded && decoded.exp > Date.now() / 1000);
}
export { tokenIsExpired };
//# sourceMappingURL=utils.js.map